<template>
  <div class="yearProcent">
    <span :class="{ active: values }" @click="values = true"
      >Отображать в % годовых</span
    >
    <span :class="{ active: !values }" @click="values = false"
      >Отображать в % от суммы гарантии</span
    >
  </div>
</template>

<script>
export default {
  name: "yearprocent",
  data: () => ({}),
  props: {
    value: { type: Boolean, default: true },
  },
  computed: {
    values: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      },
    },
  },
};
</script>

<style lang="sass">
.yearProcent
  display: flex
  align-items: center
  span
    font-size: .8em
    cursor: pointer
    // margin: 0 15px
    color: #217899
    padding: 0 5px
    overflow: hidden
    text-overflow: ellipsis
    height: 40px
    &.active
      border-bottom: 3px solid #217899
</style>
